import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../environments/environment';

export interface CreatePaymentRequest {
  token: string;
  transactionAmount: number;
  description: string;
  paymentMethodId: string;
  installments: number;
  issuerId?: string;
  payer: {
    email: string;
    identification?: {
      type: string;
      number: string;
    };
  };
  planId: string;
  planName: string;
}

export interface CreatePaymentResponse {
  status: string;
  statusDetail?: string;
  id?: number;
  transactionAmount: number;
  error?: string;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  createPayment(request: CreatePaymentRequest): Observable<CreatePaymentResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post<CreatePaymentResponse>(
      `${this.apiUrl}/api/create-payment`,
      request,
      { headers }
    ).pipe(
      catchError((error) => {
        console.error('Error creating payment:', error);
        return throwError(() => error);
      })
    );
  }
}



